import { useSubscription } from '@apollo/client/react'
import { PracticeProviderDashboardWarningNotifierSubscriptionDocument } from '@docpace/manager-graphql/dist/urql.types'
import { PracticeProviderDashboardWarningNotifierSubscriptionResultFragment } from '@docpace/manager-graphql'

export function usePracticeProviderDashboardWarningNotifierSubscription(opts: useSubscription.Options<PracticeProviderDashboardWarningNotifierSubscriptionResultFragment>){
    return useSubscription<PracticeProviderDashboardWarningNotifierSubscriptionResultFragment>(PracticeProviderDashboardWarningNotifierSubscriptionDocument, opts)
}